import { Button, Stack, Typography, styled } from '@mui/material';

export const BackgroundColor = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: '0px 0px 16px 16px',
  position: 'relative',
  left: '0px',
  top: '0px',
  alignSelf: 'stretch',
  width: '100%',
  minWidth: '90%',
  padding: '0px',
  margin: '0px',
}));

export const ContentApp = styled(Stack)({
  position: 'relative',
  flexDirection: 'row',
  margin: '0 auto',
  width: '100%',
  maxWidth: '1380px',
  height: '100%',
  alignItems: 'center',
});

export const BottonsIconosPerfile = styled(Stack)({
  width: '54px',
  height: '54px',
  position: 'absolute',
  right: '10px',
  bottom: '18px',
});

export const IconInfo = styled('img')(({ theme }) => ({
  height: '20px',
  width: '20px',
  margin: '0px 0px 0px 10px',
  backgroundColor: 'black',
  borderRadius: '50%',
}));

export const RentabilidadUltimo = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.textLightBlue,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.signInWelcome.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  lineHeight: '98%',
  textTransform: 'none',
  margin: '0px',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.h1.fontSize,
  },
}));
export const RetornoEsperado = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.textLightBlue,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
}));

export const CreateDatePorfolio = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.textLightBlue,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '4px 0px 0px 0px',
}));

export const SectionButtons = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: { md: 'row', xs: 'column' },
  justifyContent: 'center',
  alignItems: { md: 'flex-end', xs: 'center' },
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: '1380px',
  height: '100%',
  margin: '0 auto',
});

export const AreaButtons = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
  borderRadius: '8px',
  position: 'relative',
  isolation: 'isolate',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px',
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: '650px',
  minWidth: '550px',
  margin: '0px',
  bottom: '-40px',
  gap: 8,
}));

export const ButtonsInvestment = styled(Button)(({ theme }) => ({
  flex: '1',
  height: '50%',
  width: '100%',
  paddingY: '16px',
  backgroundColor: theme.palette.primary.main,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

//*Body portafolio

export const SectionDataPorfolio = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
});

export const ChartsPorfolio = styled(Stack)({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '0px',
  width: '100%',
});

export const DataCharts = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  width: '100%',
  margin: '0px',
});

export const InfoPorfolio = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  background: theme.palette.primary.hoverGradient,
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '20px 30px',
  boxSizing: 'border-box',
  width: '100%',
}));

export const TitelDataPorfolio = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.titleText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
}));

export const DescriptionDataPorfo = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '21px 0px 0px 0px',
  width: '100%',
});

//* Description data Charts

export const DescriptionComponents = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
});

export const KeyDescription = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
}));

export const KeyValue = styled(Typography)(({ theme }) => ({
  textAlign: 'end',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.mediumText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  textTransform: 'none',
  margin: '0px',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));
//* Vista Más información portfolio
export const ContainerPortfolioDetails = styled(Stack)(({ theme }) => ({
  width: '90%',
  marginTop: '48px',
  borderRadius: '16px',
  position: 'relative',
  marginInline: 'auto',
  isolation: 'isolate',
  marginBottom: '4rem',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));
export const TopSectionPortfolio = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: 'auto',
  gap: '20px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));
export const StackDescription = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  marginTop: 0,
  [theme.breakpoints.up('md')]: {
    marginTop: '20px',
  },
}));
export const TitleDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.titleText.fontWeight,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
  },
}));
export const Description = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.description.fontSize,
  textAlign: 'left',
}));
export const CardExpectedReturn = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '82px',
  isolation: 'isolate',
  padding: '12px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));
export const TypographyTitleExpected = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.primary.main,
  marginLeft: '0px',

  [theme.breakpoints.up('sm')]: {
    marginLeft: '16px',
  },
  [theme.breakpoints.up('lg')]: {
    marginLeft: '26px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));
export const TypographyValueExpected = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.title.fontSize,
  fontWeight: theme.typography.h4.fontWeight,
  marginRight: '0px',

  [theme.breakpoints.up('sm')]: {
    marginRight: '26px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.description.fontSize,
  },
}));

export const CardsContentDocumentacion = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '0px',
  boxSizing: 'border-box',
  overflow: 'hidden',
  minHeight: '188px',
  marginBottom: '-20px',
}));
export const HeaderComponent = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '8px 16px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
  height: '90px',
  width: '100%',
  flexDirection: 'column',
});
export const TitleCardsDocumentation = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.title.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  lineHeight: '105%',
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.mediumText.fontSize,
  },
}));
export const SubTitleCardsDocumentation = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.primary.dark,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.customButton.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  lineHeight: '105%',
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.customButton.fontSize,
  },
}));
export const BodyComponent = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  height: '104px',
  margin: '8px 0px 0px 0px',
  width: '100%',
});
export const BtnGroupContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  isolation: 'isolate',
  flexDirection: 'column',
  width: '40%',
  justifyContent: 'center',
  alignItems: 'flex-end',
  boxSizing: 'border-box',
  height: '82px',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: 'auto',
  },
}));
export const ButtonsWrapperStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  flex: '1 1 auto',

  [theme.breakpoints.up('md')]: {
    maxWidth: '1380px',
    alignItems: 'flex-end',
  },
}));
export const BtnGroupPortfolio = styled(Stack)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '16px',
  boxSizing: 'border-box',
  width: '100%',
  margin: '0px',
}));
export const BtnContainer = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
});

export const ButtonReInvestment = styled(Button)(({ theme }) => ({
  border: `2px solid ${theme.palette.avatar.border}`,
  flex: 1,
  height: '50px',
  margin: 0,
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  textTransform: 'none',
  fontSize: theme.typography.button.fontSize,
  background: '#F4F4FB',
  '&:hover': {
    background: '#F4F4FB',
    borderColor: theme.palette.primary.main,
  },
}));
